module.exports = __webpack_public_path__ + "static/dashboard_intro5@2x-0a7e3ab9a37c6d12bd262b48883ff1f4.png";